<template>
  <div class="step-container scrollPosition haus-step-3">
    <div class="step-header">
      <h2 class="step-title">Bauweise</h2>
      <p class="step-text">Welche Bauweise trifft auf das Haus zu?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-80"
          text="Massivhaus"
          @click="setBauweise(10)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8172.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8172_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-80"
          text="Fertigteilhaus"
          @click="setBauweise(30)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8208.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8208_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-80"
          text="Holzriegelhaus"
          @click="setBauweise(40)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8214.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8214_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-80"
          text="Blockhaus"
          @click="setBauweise(60)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8196.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8196_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-20"
          text="Nicht bekannt"
          @click="setBauweise(20)"
          :iconDefault="require('@/assets/icons/Svgs/Pfad_7646.svg')"
          :iconHover="require('@/assets/icons/Svgs/Pfad_7646_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from '@/components/shared/ActionBox.vue';
import { saveToStorage } from '@/utils.js';
export default {
  name: 'haus-step-3',
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        indexHausBauweise: { value: null },
      },
    };
  },
  methods: {
    setBauweise(index) {
      this.fields.indexHausBauweise.value = index;
      saveToStorage(this.fields);
      this.$router.push('/haus-step-4');
    },
    goBack() {
      this.$router.push('/haus-step-2');
    },
  },
  mounted() {
    this.$emit('setStep', 'haus', 4);
  },
};
</script>
<style scoped>
.box-container {
  margin: 50px;
}
.box-item {
  flex-basis: 220px;
  height: 220px;
}
@media only screen and (max-width: 768px) {
  .box-container {
    margin: 0;
  }
  .box-item {
    height: 100%;
  }
}
</style>
